import { createContext, useContext } from "react";

export const ReviewLaunchContext = createContext(null);

export function useReviewLaunch() {
  return useContext(ReviewLaunchContext);
}
